/**
 * MediaIframe
 * 
 * @Author: Focci
 * @Date: 2024-03-21 12:20:05
 * @Last Modified by: Focci
 * @Last Modified time: 2024-03-21 12:20:05
 */

import { useParseVideoUrl } from '@lib/video-url'
import { Waypoint } from 'react-waypoint'
import { useState } from 'react'

function MediaIframeVideo({ videoUrl }) {
  const { result: { url }, ready } = useParseVideoUrl(videoUrl, '0')
  
  return ready && (
    <iframe
      title="video"
      className="aspect-video w-full bg-cf0"
      src={url}
      style={{ border: 'none', maxWidth: '100%', maxHeight: '100%' }}
      allowFullScreen
    />
  )
}

function MediaIframeVR({ url }) {
  return (
    <iframe
      allowFullScreen
      title="vr"
      className="aspect-video w-full bg-cf0"
      src={url}
      style={{ border: 'none', maxWidth: '100%', maxHeight: '100%' }}
    />
  )
}

function MediaIframeScoff({ children }) {
  const [show, setShow] = useState(false)
  
  return (
    <Waypoint onEnter={() => setShow(true)}>
      <div className="aspect-video bg-cf0">
        {show && children}
      </div>
    </Waypoint>
    
  )
}

export default function MediaIframe({ house }) {
  const { videoUrl, threeDView } = house
  
  return (
    <div className="flex flex-col mt-4 gap-4">
      {videoUrl && (
        <MediaIframeScoff>
          <MediaIframeVideo videoUrl={videoUrl} />
        </MediaIframeScoff>
      )}
      {threeDView && (
        <MediaIframeScoff>
          <MediaIframeVR url={threeDView} />
        </MediaIframeScoff>
      )}
    </div>
  )
}
